export default " <ngx-ui-loader></ngx-ui-loader>\n<router-outlet></router-outlet>";